import config from "./index";

/**
 * Environment → region → preview/widget host (GHL_DOMAIN_UI) for data-residency
 * regions. Used by the version-history preview, which renders the public
 * `/widget/...` page.
 *
 * List only hosts that differ from the environment's default `GHL_DOMAIN_UI`;
 * any env/region combination not present here falls back to it. Only AU staging
 * is provisioned today — add a `production.au` entry when the prod host lands.
 * Env keys match `config.mode` ("dev" | "staging" | "interop" | "beta" | "production").
 */
const REGIONAL_GHL_DOMAIN_UI: Record<string, Record<string, string>> = {
  staging: {
    au: "https://funnel-preview-dot-hl-app-stg-au.ts.r.appspot.com",
  },
  // production: {
  //   au: "<prod-au-host>",
  // },
};

/**
 * Resolve the preview host for a tenant's data-residency region in the current
 * environment.
 * @param regionCode region code passed in via the Postmate model (JWT-derived); may be undefined.
 */
export const getGhlDomainUiForRegion = (regionCode?: string): string => {
  const region = regionCode?.trim()?.toLowerCase();
  const envMap = REGIONAL_GHL_DOMAIN_UI[config.mode] ?? {};
  return (region && envMap[region]) || config.GHL_DOMAIN_UI;
};
